export default __webpack_public_path__ + "static/FF-white-header-logo-1f3fe57e8049e382341e5c70c67f441e.svg";